import * as React from 'react';
import { Subtract } from 'utility-types';
import { ServiceLocator } from '../../app/ServiceLocator';

import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { ISanitizer, sanitize } from '../../commonInfra/utils/Sanitize';
import { IPlace } from '../../ts/models/IPlace';

export interface InjectedFlowSpaceServiceInjectorProps {
  readonly place: IPlace;
  readonly sanitizer: ISanitizer;
  readonly translate: IReactTranslateService;
}

export interface FlowSpaceServiceInjectorProps {
  readonly flowId: string;
}

export function withFlowSpaceServiceInjector<P extends InjectedFlowSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function FlowSpaceServiceInjector(
    props: Subtract<P, InjectedFlowSpaceServiceInjectorProps> & FlowSpaceServiceInjectorProps
  ) {
    const $translate = ServiceLocator.get<ng.translate.ITranslateService>('$translate');

    return <Component
      {...props as unknown as P}
      sanitizer={sanitize}
      translate={$translate.instant.bind($translate)}
    />;
  };
}
